"use strict";

/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce = typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : null;

  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}

module.exports = setAttributesWithoutAttributes;